import { nanoid } from 'nanoid'

export const generateTraceId = () => nanoid(12)
